import styled from 'styled-components';
import SeasonalHeroBanner from './SeasonalHeroBanner';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import RenderLayoutViews from '../shared/RenderLayoutViews';
import { GoogleAdSlot } from '../GoogleAdSlot/GoogleAdSlot';

const HiddenH1 = styled.h1`
  display: none;
`;

const LayoutContainerDiv = styled.div`
  margin-top: ${p => p.theme.unit(8)};
`;

const MobileLayoutContainerDiv = styled(LayoutContainerDiv)`
  margin-top: ${p => p.theme.unit(6)};
`;

const AdLayoutTitleDiv = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${p => p.theme.c.text.primary};
  margin-bottom: ${p => p.theme.unit(2)};
`;

const SeasonalContent = (props) => {
  const {
    userData,
    urlLocale,
    adConfig,
    seasonalPageData = {},
    pageStateModifiers = {},
    googleAd,
  } = props;

  const {
    displayName = '',
    layout = [],
  } = seasonalPageData;

  const adLayout = layout && layout.length ?
    layout[0] :
    [];

  const adLayoutTitle = adLayout && adLayout.displayName ?
    adLayout.displayName :
    '';

  const desktopPage = (
    <div>
      <HiddenH1>
        {displayName}
      </HiddenH1>
      <SeasonalHeroBanner seasonalPageData={seasonalPageData} />

      <LayoutContainerDiv>
        {googleAd && googleAd.active && (
          <GoogleAdSlot adId={googleAd.id} key={googleAd.id} verticalMargin={0} />
        )}

        <MaxWidthLayout>
          <AdLayoutTitleDiv>{adLayoutTitle}</AdLayoutTitleDiv>
        </MaxWidthLayout>
        <RenderLayoutViews
          views={layout}
          locale={urlLocale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
          adConfig={adConfig} />
      </LayoutContainerDiv>
    </div>
  );

  const mobilePage = (
    <div>
      <HiddenH1>
        {displayName}
      </HiddenH1>
      <SeasonalHeroBanner isMobile seasonalPageData={seasonalPageData} />
      <MobileLayoutContainerDiv>
        {googleAd && googleAd.active && (
          <GoogleAdSlot adId={googleAd.id} key={googleAd.id} verticalMargin={0} />
        )}

        <MaxWidthLayout>
          <AdLayoutTitleDiv isMobile>{adLayoutTitle}</AdLayoutTitleDiv>
        </MaxWidthLayout>
        <RenderLayoutViews
          views={layout}
          locale={urlLocale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
          adConfig={adConfig} />
      </MobileLayoutContainerDiv>
    </div>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={desktopPage}
      mobileChildren={mobilePage}
    />
  );

  return renderComp;
};

export default SeasonalContent;
